export const TOP = 'top'
export const BOTTOM = 'bottom'
export const BOTH = 'both'